module.exports = __webpack_public_path__ + "static/media/tengu.f6924b7d.jpg";